// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ro-0";